/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Share_Remove_Member_AriaInputs */

const en_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const fr_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const de_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const it_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const ru_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const es_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const zh_cn2_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const ja_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const hi_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

const pt_pt2_team_share_remove_member_aria = /** @type {(inputs: Team_Share_Remove_Member_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Remove {email}" |
*
* @param {Team_Share_Remove_Member_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_remove_member_aria = /** @type {((inputs: Team_Share_Remove_Member_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Remove_Member_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_remove_member_aria(inputs)
	if (locale === "de") return de_team_share_remove_member_aria(inputs)
	if (locale === "it") return it_team_share_remove_member_aria(inputs)
	if (locale === "ru") return ru_team_share_remove_member_aria(inputs)
	if (locale === "es") return es_team_share_remove_member_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_remove_member_aria(inputs)
	if (locale === "ja") return ja_team_share_remove_member_aria(inputs)
	if (locale === "hi") return hi_team_share_remove_member_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_remove_member_aria(inputs)
	return en_team_share_remove_member_aria(inputs)
});